<template lang="pug">
v-list(dense, shaped, nav, style="background: inherit")
  v-list-item
    v-list-item-avatar
      v-icon(color="primary", large) mdi-account-circle
    v-list-item-content
      v-list-item-title {{ userDetail.name }}
      v-list-item-subtitle {{ userDetail.corporate.corporateGroup.corporateGroupName }}
  v-divider
  f-menu-navigation(
    v-for="menu in filteredMenu",
    :key="menu.menuCode",
    :menuItem="menu",
    :active="active"
  )
</template>
<script>
import EventBus from "../../service/event-bus.service";

import _cloneDeep from "lodash/cloneDeep";
export default {
  name: "FMenu",
  props: ["active"],
  data() {
    return {
      menus: [],
      items: [],
      userDetail: { corporate: { corporateGroup: {} } },
    };
  },
  computed: {
    filteredMenu() {
      const filterMenu = (menus) => {
        return menus.filter((m) => {
          if (m.type == "ITEM") {
            if (this.userDetail.corporate.corporatePemda) {
              return this.items.find((item) => item.menuCode === m.menuCode);
            } else {
              return this.items.find(
                (item) => item.menuCode === m.menuCode && !m.pemda
              );
            }
          } else {
            let filteredChilds = filterMenu(_cloneDeep(m.children));
            m.children = filteredChilds;
            return filteredChilds.length > 0;
          }
        });
      };

      let fMenu = filterMenu(_cloneDeep(this.menus));
      return fMenu;
    },
  },
  mounted() {
    this.$session.userDetail().then((item) => {
      if (item) {
        this.userDetail = item || { corporate: { corporateGroup: {} } };
        this.getMenu();
      } else {
        EventBus.$emit("unauthorized-access", "unauthorized-access");
      }
    });
  },
  methods: {
    menuSelect(name) {
      this.$router.push({ name: name }).catch((err) => {});
    },
    getMenu() {
      this.$http.get("/api/system/menu-privilege").then((success) => {
        this.menus = success.data;
        let activeName = this.$route.name;
        this.$router.afterEach((t) => {
          activeName = t.name;
        });

        let openedMenu = this.menus
          .filter((m) => m.type === "MENU")
          .filter((m) => m.children.find((c) => c.menuCode === this.activeName))
          .map((m) => m.menuCode);

        this.$nextTick(() => {
          openedMenu.forEach((i) => {
            try {
              this.$refs.menuRef.open(i);
            } catch (e) {}
          });
        });
        this.getRoleMenu();
      });
    },
    getRoleMenu() {
      if (this.userDetail && this.userDetail.user) {
        this.$http
          .get("/api/system/role-menu/" + this.userDetail.user.roleId)
          .then((success) => {
            this.items = success.data;
          });
      }
    },
  },
};
</script>
